import { formatDateForAPI } from '@/features/invitee/utils/inviteeFormatters'
import type { PmcPerformanceRedFilterState } from '../../types/filters'
import type { PmcPerformanceRedListParams, PmcPerformanceRedSortKey } from '../../types/pages'

export const yearStart = formatDateForAPI(new Date(new Date().getFullYear(), 0, 1))

export const DEFAULT_FILTER: PmcPerformanceRedFilterState = {
  sales_team: [],
  fromDt: yearStart,
  toDt: formatDateForAPI(new Date()),
  company_id: '',
  company_name: '',
  isRolling: false,
}

export const DEFAULT_PARAMS: PmcPerformanceRedListParams = {
  ...DEFAULT_FILTER,
  page: 1,
  perPage: 20,
  sortBy: 'desc',
  orderBy: 'certificates',
}

export const SORT_COLUMNS: { key: PmcPerformanceRedSortKey; label: string }[] = [
  { key: 'company_name', label: 'PMC' },
  { key: 'certificates', label: 'Contracts' },
  { key: 'change_certificates', label: '% Change' },
  { key: 'delta_certificates', label: 'Δ' },
  { key: 'sales_exec', label: 'Sales Exec' },
  { key: 'manager_name', label: 'Acct Mgr' },
  { key: 'loss_ratio', label: 'Loss Ratio' },
  { key: 'occupancy', label: 'Occupancy' },
]
